import { render, staticRenderFns } from "./BlackPinTransactions.vue?vue&type=template&id=32a205bf&"
import script from "./BlackPinTransactions.vue?vue&type=script&lang=js&"
export * from "./BlackPinTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports